import {
  ADD_NEW_STEP,
  EDIT_ADDON_STEP_TITLE,
  ADD_STEP_DATA,
  CLEAR_ADDON_STEP,
  REMOVE_ADDON_STEP_ITEM,
  REMOVE_ADDON_STEP,
  CLEAR_ALL_ADDONS_STEPS,
  ADD_VARIATION_ITEM,
  EDIT_VARIATION_ITEM,
  REMOVE_VARIATION_ITEM,
  ORDER_VARIATION_ITEM,
  CLOSE_STEP_DATA_SELECTION_MODAL,
  SELECT_CURRENT_STEP_SELECTION,
  SET_COMBO_STEPS,
  SET_PRODUCT_VARIATIONS_DATA,
} from './actions';
import { VARIATION_DRAG_DROP_COLUMNS, PRODUCT_ADDONS } from '../../helpers/constants';

const initialState = {
  currStep: {},
  steps: [
    {
      id: 0,
      title: '',
      addonType: PRODUCT_ADDONS.SELECTED_PRODUCTS,
      data: null,
      onlyProducts: true,
    },
  ],
  variations: {
    id: VARIATION_DRAG_DROP_COLUMNS.PRODUCT_VARIATIONS,
    list: [],
  },
};

export default function productAddons(state = initialState, action) {
  switch (action.type) {
    case ADD_NEW_STEP:
      return {
        ...state,
        steps: [
          ...state.steps,
          {
            id: state.steps[state.steps.length - 1].id + 1,
            title: '',
            data: null,
          },
        ],
      };
    case EDIT_ADDON_STEP_TITLE:
      return {
        ...state,
        steps: state.steps.map(step =>
          step.id === action.step
            ? {
                ...step,
                title: action.title,
              }
            : step
        ),
      };
    case ADD_STEP_DATA:
      return {
        ...state,
        currStep: {},
        steps: state.steps.map(step =>
          step.id === action.step
            ? {
                ...step,
                data: action.data,
                addonType: action.addonType,
              }
            : step
        ),
      };
    case CLEAR_ADDON_STEP:
      return {
        ...state,
        steps: state.steps.map(step =>
          step.id === action.step
            ? {
                ...step,
                data: null,
                addonType: null,
              }
            : step
        ),
      };
    case REMOVE_ADDON_STEP_ITEM:
      return {
        ...state,
        steps: state.steps.map(step =>
          step.id === action.step
            ? {
                ...step,
                data:
                  step.addonType === PRODUCT_ADDONS.SELECTED_PRODUCTS
                    ? removeProductItemFromStep(step.data, action.id)
                    : null,
                addonType:
                  step.addonType === PRODUCT_ADDONS.SELECTED_PRODUCTS
                    ? isLastProductItem(step.data)
                      ? null
                      : step.addonType
                    : null,
              }
            : step
        ),
      };
    case REMOVE_ADDON_STEP:
      return {
        ...state,
        steps: state.steps.filter(step => step.id !== action.step),
      };
    case CLEAR_ALL_ADDONS_STEPS:
      return { ...initialState };
    case CLOSE_STEP_DATA_SELECTION_MODAL:
      return {
        ...state,
        steps: state.steps.map(step =>
          step.id === state.currStep.id && action.clearStep
            ? {
                ...step,
                addonType: null,
                data: null,
              }
            : step
        ),
        currStep: {},
      };
    case SELECT_CURRENT_STEP_SELECTION:
      return {
        ...state,
        currStep: {
          ...action.step,
          addonType: action.addonType,
        },
      };
    case ADD_VARIATION_ITEM:
      let variations = [...state.variations.list];
      variations.splice(action.order, 0, {
        ...action.variation,
        isGlobal: !!action.isGlobal,
      });

      return {
        ...state,
        variations: {
          ...state.variations,
          list: variations,
        },
      };
    case EDIT_VARIATION_ITEM:
      return {
        ...state,
        variations: {
          ...state.variations,
          list: state.variations.list.map(variation =>
            variation.id === action.variation.id ? action.variation : variation
          ),
        },
      };
    case REMOVE_VARIATION_ITEM:
      return {
        ...state,
        variations: {
          ...state.variations,
          list: state.variations.list.filter(variation => variation.id !== action.variationId),
        },
      };
    case ORDER_VARIATION_ITEM:
      let orderVariations = [...state.variations.list];
      const variation = state.variations.list[action.currPos];

      orderVariations.splice(action.currPos, 1);
      orderVariations.splice(action.newPos, 0, variation);

      return {
        ...state,
        variations: {
          ...state.variations,
          list: orderVariations,
        },
      };
    case SET_COMBO_STEPS:
      return {
        ...state,
        steps: action.steps,
      };
    case SET_PRODUCT_VARIATIONS_DATA:
      return {
        ...state,
        variations: {
          id: state.variations.id,
          list: action.variations,
        },
      };
    default:
      return state;
  }
}

const isLastProductItem = cat => {
  let qtdProductsSelected = 0;
  cat.forEach(cat => (qtdProductsSelected += cat.products.filter(item => item.checked).length));
  return qtdProductsSelected === 1;
};

const removeProductItemFromStep = (categories, idProduct) => {
  if (isLastProductItem(categories)) {
    return null;
  }
  return categories.map(cat => ({
    ...cat,
    products: cat.products.map(prod =>
      prod.id === idProduct
        ? {
            ...prod,
            checked: false,
          }
        : prod
    ),
  }));
};



// WEBPACK FOOTER //
// ./src/store/productAddons/reducer.js